export let Weekdays = /*#__PURE__*/function (Weekdays) {
  Weekdays[Weekdays["SUNDAY"] = 0] = "SUNDAY";
  Weekdays[Weekdays["MONDAY"] = 1] = "MONDAY";
  return Weekdays;
}({});
//# sourceMappingURL=Weekdays.js.map